import { render } from "./SaLinkedin2209.vue?vue&type=template&id=965376c4"
import script from "./SaLinkedin2209.vue?vue&type=script&lang=js"
export * from "./SaLinkedin2209.vue?vue&type=script&lang=js"

import "./SaLinkedin2209.vue?vue&type=style&index=0&id=965376c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__